export default __webpack_public_path__ + "static/media/19_Helloo.4f4d5def.JPG";